import React from "react";
import { FiCheckCircle, FiCircle } from "react-icons/fi";

// CircularMatchingScore component (inlined)
function CircularMatchingScore({ score = 0 }) {
  if (score === null)
    return (
      <div className="shrink-0 flex items-center justify-center overflow-hidden relative" style={{ height: "35px", width: "35px", maxHeight: "35px", maxWidth: "35px" }}></div>
    );
  return (
    <div
      className="shrink-0 flex items-center justify-center overflow-hidden relative border border-gray-200 rounded-full"
      style={{ height: "35px", width: "35px", maxHeight: "35px", maxWidth: "35px" }}
    >
      <svg className="w-full h-full" viewBox="0 0 60 60">
        <circle
          cx="30"
          cy="30"
          r="25"
          fill="none"
          stroke={score > 70 ? "#10B981" : score > 50 ? "#3B82F6" : "#6B7280"}
          strokeWidth="5"
          strokeDasharray={`${score !== null ? (2 * Math.PI * 25 * score) / 100 : 0} ${2 * Math.PI * 25 - (score !== null ? (2 * Math.PI * 25 * score) / 100 : 0)}`}
          transform="rotate(-90 30 30)"
        />
      </svg>
      <span
        className="text-sm font-semibold leading-none absolute"
        style={{
          color: score > 70 ? "#10B981" : score > 50 ? "#3B82F6" : "#6B7280",
          fontSize: "0.60rem",
        }}
      >
        {score === null ? "N/A" : `${score}%`}
      </span>
    </div>
  );
}

export default function ProfileCompletion({ values }) {
  const completionTasks = [
    { label: "Add profile photo", completed: !!values.avatar, points: 10 },
    { label: "Write a bio", completed: !!values.about, points: 10 },
    { label: "Add work experience", completed: values.experiences?.length > 0, points: 25 },
    { label: "Add education", completed: values.education?.length > 0, points: 25 },
    { label: "Add 5+ skills", completed: values.skills?.length >= 5, points: 15 },
    { label: "Add languages", completed: values.languages?.length > 0, points: 15 },
  ];

  const progress = completionTasks.reduce((acc, task) => (task.completed ? acc + task.points : acc), 0);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-lg font-bold text-gray-900">Profile Strength</h2>
          <p className="text-sm text-gray-500">Complete your profile</p>
        </div>
        <div className="transform scale-125">
          <CircularMatchingScore score={progress} />
        </div>
      </div>
      
      <div className="space-y-4">
        {completionTasks.map((task, index) => (
          <div key={index} className="flex items-center justify-between p-2 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer group">
            <div className="flex items-center gap-3">
              {task.completed ? (
                <FiCheckCircle className="w-5 h-5 text-green-500 shrink-0" />
              ) : (
                <FiCircle className="w-5 h-5 text-gray-300 shrink-0 group-hover:text-blue-500" />
              )}
              <span className={`text-sm ${task.completed ? "text-gray-900" : "text-gray-600"}`}>
                {task.label}
              </span>
            </div>
            {!task.completed && (
              <span className="text-xs font-medium text-blue-600 bg-blue-50 px-2 py-1 rounded-full">
                +{task.points}%
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

